'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _BaseContentCard = require('../BaseContentCard');

var _BaseContentCard2 = _interopRequireDefault(_BaseContentCard);

var _ContentCardPaywall = require('../ContentCardPaywall');

var _ContentCardPaywall2 = _interopRequireDefault(_ContentCardPaywall);

var _ShareArticle = require('../ShareArticle/ShareArticle');

var _ShareArticle2 = _interopRequireDefault(_ShareArticle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForecastArticleCard = function (_Component) {
  (0, _inherits3.default)(ForecastArticleCard, _Component);

  function ForecastArticleCard(props) {
    (0, _classCallCheck3.default)(this, ForecastArticleCard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ForecastArticleCard.__proto__ || (0, _getPrototypeOf2.default)(ForecastArticleCard)).call(this, props));

    _this.applyVideoEvent = function (vid) {
      var currVid = vid;
      var contentId = (0, _lodash.get)(currVid, 'offsetParent.id', null);
      var title = (0, _lodash.get)(currVid, 'attributes.alt.value', null);
      currVid.onplay = function () {
        if (!(0, _lodash.includes)(_this.state.clickedVideoIds, contentId)) {
          _this.props.doTrackFeed('Played Video', { title: title, contentId: contentId, category: _this.props.segmentCategory });
          _this.setState((0, _extends3.default)({}, _this.state, {
            clickedVideoIds: _this.state.clickedVideoIds.concat([contentId])
          }));
        }
      };
    };

    _this.className = function () {
      return (0, _classnames2.default)({
        'quiver-forecast-article-card': true,
        'quiver-forecast-article-card--premium': _this.props.premium,
        'quiver-forecast-article-card--expert': _this.props.expert,
        'quiver-forecast-article-card--show-more': _this.showAll || _this.state.showMore
      });
    };

    _this.meta = function () {
      var _this$props = _this.props,
          author = _this$props.author,
          premium = _this$props.premium,
          expert = _this$props.expert,
          publishedDateTime = _this$props.publishedDateTime;

      return '\n      ' + (author ? 'By ' + author + ' \u2022 ' : '') + '\n      ' + (premium ? 'Premium ' : '') + '\n      ' + (expert ? 'Expert Forecast •' : '') + '\n      ' + publishedDateTime + '\n    ';
    };

    _this.toggleShowMore = function () {
      return _this.setState({ showMore: !_this.state.showMore });
    };

    _this.checkShouldShowAll = function () {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var matchedImages = content ? content.match(/<img/ig) : [];
      if (matchedImages && matchedImages.length > 1) return false;

      var chCount = content ? content.replace(/(<([^>]+)>)/ig, '').length : 0;
      return chCount < 400;
    };

    _this.showAll = props.showFullArticle || _this.checkShouldShowAll(props.body);
    _this.state = {
      showMore: false,
      clickedVideoIds: []
    };
    return _this;
  }

  (0, _createClass3.default)(ForecastArticleCard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var vidTags = document.getElementsByTagName('video');
      if (vidTags.length) {
        var videos = [].concat((0, _toConsumableArray3.default)(vidTags));
        videos.forEach(function (vid) {
          _this2.applyVideoEvent(vid);
        });
      }
    }

    // if there are less than 500 characters don't show "read more"
    // https://wavetrak.atlassian.net/wiki/spaces/IE/pages/130496072/Read+More+Truncating+Notes

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          premium = _props.premium,
          id = _props.id,
          title = _props.title,
          body = _props.body,
          tags = _props.tags,
          showPaywall = _props.showPaywall,
          onClickReadMore = _props.onClickReadMore,
          onClickShareArticle = _props.onClickShareArticle,
          funnelUrl = _props.funnelUrl,
          onClickPaywall = _props.onClickPaywall,
          fbAppId = _props.fbAppId,
          url = _props.url,
          showShare = _props.showShare;
      var showMore = this.state.showMore;


      return _react2.default.createElement(
        'div',
        {
          className: this.className(premium)
        },
        _react2.default.createElement(
          _BaseContentCard2.default,
          {
            meta: this.meta(),
            tags: tags.map(function (_ref) {
              var name = _ref.name;
              return { name: name };
            }),
            showPaywall: showPaywall
          },
          _react2.default.createElement(
            'h2',
            null,
            title
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('div', {
              className: 'quiver-forecast-article-card__body',
              dangerouslySetInnerHTML: { __html: body },
              id: id
            }),
            (this.showAll || showMore) && fbAppId && url && showShare ? _react2.default.createElement(
              'div',
              { className: 'quiver-forecast-article-card__body__share' },
              _react2.default.createElement(
                'span',
                { className: 'quiver-forecast-article-card__body__share__title' },
                'Share this post'
              ),
              _react2.default.createElement(_ShareArticle2.default, { fbAppId: fbAppId, url: url, onClickLink: onClickShareArticle })
            ) : null,
            !this.showAll && !showPaywall ? _react2.default.createElement(
              'a',
              {
                className: 'quiver-forecast-article-card__read-more-less',
                onClick: this.toggleShowMore
              },
              _react2.default.createElement(
                'span',
                {
                  onClick: onClickReadMore
                },
                showMore ? 'Read Less' : 'Read More'
              )
            ) : null
          )
        ),
        showPaywall && _react2.default.createElement(_ContentCardPaywall2.default, { funnelUrl: funnelUrl, onClick: onClickPaywall })
      );
    }
  }]);
  return ForecastArticleCard;
}(_react.Component);

ForecastArticleCard.propTypes = {
  author: _propTypes2.default.string,
  publishedDateTime: _propTypes2.default.string.isRequired,
  id: _propTypes2.default.string,
  premium: _propTypes2.default.bool,
  expert: _propTypes2.default.bool,
  title: _propTypes2.default.string.isRequired,
  body: _propTypes2.default.string,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired
  })).isRequired,
  showPaywall: _propTypes2.default.bool,
  isPremium: _propTypes2.default.bool,
  showFullArticle: _propTypes2.default.bool,
  funnelUrl: _propTypes2.default.string,
  onClickPaywall: _propTypes2.default.func,
  onClickReadMore: _propTypes2.default.func,
  onClickShareArticle: _propTypes2.default.func,
  doTrackFeed: _propTypes2.default.func,
  segmentCategory: _propTypes2.default.string,
  fbAppId: _propTypes2.default.string,
  url: _propTypes2.default.string,
  showShare: _propTypes2.default.bool
};
ForecastArticleCard.defaultProps = {
  author: null,
  id: null,
  premium: false,
  body: null,
  showPaywall: false,
  showFullArticle: false,
  isPremium: true,
  funnelUrl: null,
  onClickPaywall: null,
  onClickReadMore: null,
  onClickShareArticle: null,
  doTrackFeed: null,
  expert: false,
  segmentCategory: null,
  fbAppId: null,
  url: null,
  showShare: true
};
exports.default = ForecastArticleCard;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ForecastArticleCard/ForecastArticleCard.js
// module id = 582
// module chunks = 11